@if (form) {
  <form [formGroup]="form">
    @if (loaded) {
      <se-fe-form-field
    [seFeDataConfig]="{
        label: seFeDataLabel,
        required: isRequired,
        errorMessages: {
          required: 'SE_PO_UI_STATE_SELECT.ERRORS.required' | translate
        }
      }">
      <se-fe-select
        [formControlName]="ngControl.name"
        [seFeDataOptions]="stateOptions">
      </se-fe-select>
    </se-fe-form-field>
  }
</form>
}
